import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconCreditCardPayment = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M5.5 15.25C5.08579 15.25 4.75 15.5858 4.75 16C4.75 16.4142 5.08579 16.75 5.5 16.75H8.5C8.91421 16.75 9.25 16.4142 9.25 16C9.25 15.5858 8.91421 15.25 8.5 15.25H5.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.25 16C10.25 15.5858 10.5858 15.25 11 15.25H14C14.4142 15.25 14.75 15.5858 14.75 16C14.75 16.4142 14.4142 16.75 14 16.75H11C10.5858 16.75 10.25 16.4142 10.25 16Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6 6.75C5.0335 6.75 4.25 7.5335 4.25 8.5V10.5C4.25 11.4665 5.0335 12.25 6 12.25H8C8.9665 12.25 9.75 11.4665 9.75 10.5V8.5C9.75 7.5335 8.9665 6.75 8 6.75H6ZM5.75 8.5C5.75 8.36193 5.86193 8.25 6 8.25H8C8.13807 8.25 8.25 8.36193 8.25 8.5V10.5C8.25 10.6381 8.13807 10.75 8 10.75H6C5.86193 10.75 5.75 10.6381 5.75 10.5V8.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M5 3.75C2.92893 3.75 1.25 5.42893 1.25 7.5V16.5C1.25 18.5711 2.92893 20.25 5 20.25H19C21.0711 20.25 22.75 18.5711 22.75 16.5V7.5C22.75 5.42893 21.0711 3.75 19 3.75H5ZM2.75 7.5C2.75 6.25736 3.75736 5.25 5 5.25H19C20.2426 5.25 21.25 6.25736 21.25 7.5V16.5C21.25 17.7426 20.2426 18.75 19 18.75H5C3.75736 18.75 2.75 17.7426 2.75 16.5V7.5Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconCreditCardPayment as ReactComponent };
